













































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Preferential from "../../store/entities/booking/preferential";
import CourtSelect from '../../components/court-select.vue';
import Ajax from '../../lib/ajax';
import DateCheckbox from '../../components/date-checkbox.vue';


@Component({
    components: { CourtSelect,DateCheckbox }
})
export default class CreatePreferential extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    preferential: Preferential = new Preferential();

    // 保存订单
    save() {
        (this.$refs.preferentialForm as any).validate(async (valid: boolean) => {
            if (valid) {

                await this.$store.dispatch({
                    type: "preferential/update",
                    data: this.preferential
                });
                (this.$refs.preferentialForm as any).resetFields();

                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.preferentialForm as any).resetFields();

        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.preferential = Util.extend(
                true,
                this.preferential,
                this.$store.state.preferential.editPreferential
            );
            //console.log(this.preferential);
        }
    }
    async created(){
    }
    preferentialRule = {
        startDate: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, this.L("StartDate")),
                trigger: "change"
            }
        ],
        endDate: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, this.L("EndDate")),
                trigger: "change"
            }
        ],
        dateType: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, '日期类型'),
                trigger: "change"
            }
        ],
        courtIds: [
            {
                required:true,
                message: this.L("SelectIsRequired", undefined, this.L("Court")),
                trigger: "change"
            }
        ]
    };
}
